/* eslint-disable quotes */

/***
 * THIS FILE IS AUTOGENERATED
 * To make persistent changes to it, edit the script in:
 *  scripts\write-locales.js
 */

const langs = [
  "en-us"
]
export default langs
